<template>
  <v-row no-gutters class="py-4 text-center">
    <v-col cols="4" class="text-truncate">
      <div class="text-caption">{{ __('alreadyPaid') }}</div>
      <div class="text-body-1">{{ paidAmount | currency }}</div>
    </v-col>
    <v-col cols="4" class="text-truncate">
      <div class="text-caption">{{ __('toPay') }}</div>
      <div class="text-h5">{{ nonNegativeAmountToPay | currency }}</div>
    </v-col>
    <v-col cols="4" class="text-truncate">
      <div class="text-caption">{{ __('change') }}</div>
      <div class="text-body-1">{{ change | currency }}</div>
    </v-col>
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      Currenciable,
      I18n,
    ],

    props: {
      amount: {
        required: true,
        type: String,
      },
    },

    computed: {
      ...mapState('orders/payment', [
        'paidAmount',
        'amountToPay',
        'tipAmount',
      ]),
      nonNegativeAmountToPay () {
        return Math.max(this.amountToPay + this.tipAmount, 0)
      },
      change () {
        if (this.nonNegativeAmountToPay.equalTo(0)) {
          return 0
        }
        const amount = parseInt(this.amount) / 100
        const change = amount - this.nonNegativeAmountToPay
        return change.lessThan(0) ? 0 : change
      },
    },
  }
</script>
